export default __webpack_public_path__ + "static/media/badge-earn.979a63dbda5f6692b9fd1ad27b5fac1b.mp3";